var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"badge text-uppercase link-hover",class:_vm.upload_status,on:{"click":function($event){return _vm.getRecord()}}},[_vm._v(_vm._s(_vm.record.status || _vm.upload.status))])])
}
var staticRenderFns = []

export { render, staticRenderFns }